module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 9
// module chunks = 0